"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var interfaceLanguages_json_1 = __importDefault(require("stremio/common/interfaceLanguages.json"));
var useLanguageSorting = function (options) {
    var userLangCode = (0, react_1.useMemo)(function () {
        var lang = interfaceLanguages_json_1.default.find(function (l) { return l.codes.includes(navigator.language || 'en-US'); });
        if (lang) {
            var threeLetter = lang.codes[1] || 'eng';
            var fullLocale = navigator.language || 'en-US';
            return [threeLetter, fullLocale];
        }
        return ['eng'];
    }, []);
    var isLanguageDropdown = (0, react_1.useMemo)(function () {
        return options === null || options === void 0 ? void 0 : options.some(function (opt) { return interfaceLanguages_json_1.default.some(function (l) { return l.name === opt.label; }); });
    }, [options]);
    var sortedOptions = (0, react_1.useMemo)(function () {
        var matchingIndex = options.findIndex(function (opt) {
            var lang = interfaceLanguages_json_1.default.find(function (l) { return l.name === opt.label; });
            return userLangCode.some(function (code) { return lang === null || lang === void 0 ? void 0 : lang.codes.includes(code); });
        });
        if (matchingIndex === -1) {
            return __spreadArray([], options, true).sort(function (a, b) { return a.label.localeCompare(b.label); });
        }
        var matchingOption = options[matchingIndex];
        var otherOptions = options.filter(function (_, idx) { return idx !== matchingIndex; }).sort(function (a, b) { return a.label.localeCompare(b.label); });
        return __spreadArray([matchingOption], otherOptions, true);
    }, [options, userLangCode, isLanguageDropdown]);
    return { userLangCode: userLangCode, isLanguageDropdown: isLanguageDropdown, sortedOptions: sortedOptions };
};
exports.default = useLanguageSorting;
